import styles from "@/components/float-notification.module.css";
import { globals } from "@/globals";
import * as signals from "@/signals";
import { handleKeyboardClick } from "@/utils";
import clsx from "clsx";
import { t } from "i18next";
import { JSX, MouseEvent, useState } from "react";

function FloatNotification(): JSX.Element {
	const [isClosing, setIsClosing] = useState<boolean>(false);

	const closeNotification = (event?: MouseEvent<HTMLButtonElement>): void => {
		event?.stopPropagation();
		globals.floatNotificationCallback = null;
		setIsClosing(true);
		window.setTimeout(() => {
			signals.floatNotification.value = {};
			setIsClosing(false);
		}, globals.ANIMATION_WAIT_TIME);
	};

	const handleClick = (): void => {
		const toastMessage = globals.floatNotificationCallback?.();
		if (toastMessage) {
			signals.floatNotification.value = {
				...signals.floatNotification.value,
				toastMessage,
			};
			window.setTimeout(closeNotification, 1500);
		} else {
			closeNotification();
		}
	};

	const floatNotification = signals.floatNotification.value;
	if (!floatNotification.text || !floatNotification.title) {
		return <></>;
	}
	return (
		<div
			className={clsx(
				styles["float-notification"],
				!isClosing && "fade-in-scale",
				isClosing && "fade-out-scale",
			)}
			role="button"
			tabIndex={0}
			onClick={handleClick}
			onKeyDown={handleKeyboardClick(handleClick)}
		>
			<div className={styles["icon"]}></div>
			<div className={styles["content"]}>
				{floatNotification.toastMessage && (
					<div className={styles["toast-message"]}>
						{floatNotification.toastMessage}
					</div>
				)}
				<div
					className={clsx(
						!!floatNotification.toastMessage &&
							styles["slide-out-to-bottom"],
					)}
				>
					<h1>{floatNotification.title}</h1>
					<p className={styles["description"]}>
						{floatNotification.text?.replace(/\r|\n/g, "")}
					</p>
				</div>
			</div>
			<button
				type="button"
				onClick={closeNotification}
			>
				{t("close")}
			</button>
		</div>
	);
}

export default FloatNotification;
